/**
 * AgentForge brain picker — four catalog tabs from @forgesuite/gpu-browser.
 */

import { PiLightningBold, PiPlugBold } from "react-icons/pi";

import type { AgentBrain } from "../lib/endpoint";
import { saveEndpoint } from "../lib/endpoint";
import type { WalletSnapshot } from "../suite/types";
import { pickEngineFromRuntime } from "@forgesuite/gpu-browser";
import { useCatalogRuntime } from "../lib/useCatalogRuntime";
import { GpuBrowserMount } from "./GpuBrowserMount";

type Props = {
  brain: AgentBrain | null;
  onBrainChange: (b: AgentBrain | null) => void;
  wallet: WalletSnapshot | null;
  onStatus: (msg: string) => void;
};

export function BrainPicker({
  brain,
  onBrainChange,
  wallet,
  onStatus,
}: Props) {
  const { selectorOn, runtime } = useCatalogRuntime("agentforge");
  const pickEngine = pickEngineFromRuntime(runtime);
  const applyBrain = (b: AgentBrain | null) => {
    saveEndpoint(b);
    onBrainChange(b);
  };

  return (
    <section className="af-panel af-panel--brain">
      <div className="af-brain-head">
        <h2>
          <PiLightningBold /> Brain
        </h2>
        <p className="af-muted">
          {selectorOn === false
            ? `AccessHub Pick drives generate${pickEngine ? ` · ${pickEngine.name}` : ""}. Turn on In-app selector in AccessHub Filter to browse engines here.`
            : (
              <>
                Connect a model from <strong>HF models</strong>, <strong>Cloudflare</strong>,{" "}
                <strong>CivitAI</strong>, or <strong>Forge endpoints</strong>.
              </>
            )}
        </p>
      </div>

      {brain && (
        <div className="af-brain-active">
          <PiPlugBold />
          <div>
            <strong>{brain.label || "Connected brain"}</strong>
            <span className="af-muted">
              {" "}
              · {brain.source} · {brain.model || brain.bindKind}
            </span>
            <div className="af-mono af-brain-url">{brain.endpointUrl}</div>
          </div>
          <button type="button" className="af-chip" onClick={() => applyBrain(null)}>
            Clear
          </button>
        </div>
      )}

      {selectorOn === true && (
        <GpuBrowserMount
          wallet={wallet}
          onStatus={onStatus}
          onBrainChange={onBrainChange}
          tool="brain"
        />
      )}
    </section>
  );
}
